function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBonus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.243,1.757a6,6,0,0,0-8.485,8.485,6,6,0,0,0,8.485-8.485ZM6,5.625a1.687,1.687,0,0,1,.461,3.31.118.118,0,0,0-.086.113v.316a.382.382,0,0,1-.357.385.375.375,0,0,1-.393-.375V9.048a.117.117,0,0,0-.086-.113A1.69,1.69,0,0,1,4.313,7.323a.381.381,0,0,1,.364-.385.375.375,0,0,1,.386.375A.938.938,0,1,0,6,6.375a1.687,1.687,0,0,1-.461-3.31.118.118,0,0,0,.086-.113V2.636a.382.382,0,0,1,.357-.385.375.375,0,0,1,.393.375v.327a.117.117,0,0,0,.086.113A1.69,1.69,0,0,1,7.687,4.677a.381.381,0,0,1-.364.385.375.375,0,0,1-.386-.375A.938.938,0,1,0,6,5.625Z",
    style: {
      fill: "#999"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBonus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_bonus.e44312125c95cbe7ad21c6acb7ef7c14.svg";